import Head from 'next/head'
import PageTitle from '../../components/page-title'

export default function Privacy() {
  return (
    <>
      <Head>
        <title>privauto | Privacy Policy</title>
      </Head>

      <div className='container'>
        <section className='title'>
          <PageTitle>
            PRIVACY POLICY <br /> D2D AUTO AUCTION LLC (dba privauto)
          </PageTitle>
          <span>Last updated March 24, 2021</span>
        </section>
        <main className='content'>
          <section className='big'>
            <h2>Introduction</h2>
            <p>
              D2D Auto Auction LLC (dba privauto) (“we” or “us” or “our”) respects the privacy
              of our users (“user” or “you”). This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you visit our website
              www.privauto.com and our mobile application, including any other media form,
              media channel, mobile website, or mobile application related or connected thereto
              (collectively, the “Site”). Please read this privacy policy carefully. If you do not
              agree with the terms of this privacy policy, please do not access the site.
            </p>
            <p>
              We reserve the right to make changes to this Privacy Policy at any time and for any
              reason. We will alert you about any changes by updating the “Last Updated” date of
              this Privacy Policy. Any changes or modifications will be effective immediately upon
              posting the updated Privacy Policy on the Site, and you waive the right to receive
              specific notice of each such change or modification
            </p>
            <p>
              You are encouraged to periodically review this Privacy Policy to stay informed of
              updates. You will be deemed to have been made aware of, will be subject to, and will
              be deemed to have accepted the changes in any revised Privacy Policy by your continued
              use of the Site after the date such revised Privacy Policy is posted.
            </p>
          </section>

          <section className='big'>
            <h2>COLLECTION OF YOUR INFORMATION</h2>
            <p>
              We may collect information about you in a variety of ways. The information we may
              collect on the Site includes:
            </p>
          </section>

          <section className='small'>
            <h3>Personal Data</h3>
            <p>
              Personally identifiable information, such as your name, address, email address,
              telephone number, and detailed vehicle information including the VIN (Vehicle
              Identification Number). You are under no obligation to provide us with personal
              information of any kind, however your refusal to do so may prevent you from using
              certain features of the Site and our mobile application.
            </p>
          </section>

          <section className='small'>
            <h3>Derivative Data</h3>
            <p>
              Information our servers automatically collect when you access the Site, such as your
              IP address, your browser type, your operating system, your access times, and the pages
              you have viewed directly before and after accessing the Site. If you are using our
              mobile application, this information may also include your device name and type, your
              operating system, your phone number, your country, and other interactions with the
              application and other users via server log files, as well as any other information you
              choose to provide.
            </p>
          </section>

          <section className='small'>
            <h3>Financial Data</h3>
            <p>We do not collect or store any financial information.</p>
          </section>

          <section className='small'>
            <h3>Mobile Device Data</h3>
            <p>
              Device information, such as your mobile device ID, model, and manufacturer, and
              information about the location of your device, if you access the Site from a mobile
              device.
            </p>
          </section>

          <section className='small'>
            <h3>Third-Party Data</h3>
            <p>
              Information from third parties, such as personal information or network friends, if
              you connect your account to the third party and grant the Site permission to access
              this information.
            </p>
          </section>

          <section className='small'>
            <h3>Mobile Application Information</h3>
            <p>If you connect using our mobile application:</p>
            <ul>
              <li>
                Geo-Location Information. We may request access or permission to and track
                location-based information from your mobile device, either continuously or while you
                are using our mobile application, to provide location-based services. If you wish to
                change our access or permissions, you may do so in your device’s settings.
              </li>
              <li>
                Mobile Device Access. We may request access or permission to certain features from
                your mobile device, including your mobile device’s bluetooth, calendar, camera,
                contacts, microphone, reminders, sensors, SMS messages, storage, and other features.
                If you wish to change our access or permissions, you may do so in your device’s
                settings.
              </li>
              <li>
                Mobile Device Data. We may collect device information (such as your mobile device
                ID, model and manufacturer), operating system, version information and IP address.
              </li>
              <li>
                Push Notifications. We may request to send you push notifications regarding your
                account or the Application. If you wish to opt-out from receiving these types of
                communications, you may turn them off in your device’s settings.
              </li>
            </ul>
          </section>

          <section className='big'>
            <h2>USE OF YOUR INFORMATION</h2>
            <p>
              Having accurate information about you permits us to provide you with a smooth,
              efficient, and customized experience. Specifically, we may use information collected
              about you via the Site or our mobile application to:
            </p>
            <ul>
              <li> Assist law enforcement and respond to subpoena.</li>
              <li>
                Compile anonymous statistical data and analysis for use internally or with third
              </li>
              <li> Create and manage your account.</li>
              <li>
                Deliver targeted advertising, coupons, newsletters, and other information regarding
                promotions and the Site and our mobile application to you.
              </li>
              <li> Email you regarding your account.</li>
              <li> Enable user-to-user communications.</li>
              <li>
                Fulfill and manage purchases, orders, payments, and other transactions related to
                the Site and our mobile application.
              </li>
              <li>
                Generate a personal profile about you to make future visits to the Site and our
                mobile application more personalized.
              </li>
              <li>Increase the efficiency and operation of the Site and our mobile application.</li>
              <li>
                Monitor and analyze usage and trends to improve your experience with the Site and
                our mobile application.
              </li>
              <li> Notify you of updates to the Site and our mobile application.</li>
              <li>
                Offer new products, services, mobile application and/or recommendations to you.
              </li>
              <li> Perform other business activities as needed.</li>
              <li>
                Prevent fraudulent transactions, monitor against theft, and protect against criminal
                activity.
              </li>
              <li>
                Request feedback and contact you about your use of the Site and our mobile
                application.
              </li>
              <li>Resolve disputes and troubleshoot problems.</li>
              <li>Respond to product and customer service requests.</li>
              <li>Send you a newsletter.</li>
              <li>Solicit support for the Site and our mobile application.</li>
            </ul>
          </section>

          <section className='big'>
            <h2>DISCLOSURE OF YOUR INFORMATION</h2>
            <p>
              We may share information we have collected about you in certain situations. Your
              information may be disclosed as follows:
            </p>
          </section>

          <section className='small'>
            <h3>By Law or to Protect Rights</h3>
            <p>
              If we believe the release of information about you is necessary to respond to legal
              process, to investigate or remedy potential violations of our policies, or to protect
              the rights, property, and safety of others, we may share your information as permitted
              or required by any applicable law, rule, or regulation. This includes exchanging
              information with other entities for fraud protection and credit risk reduction.
            </p>
          </section>

          <section className='small'>
            <h3>Third-Party Service Providers</h3>
            <p>
              We may share your information with third parties that perform services for us or on
              our behalf, including data analysis, email delivery, hosting services, customer
              service, and marketing assistance.
            </p>
          </section>

          <section className='small'>
            <h3>Marketing Communications</h3>
            <p>
              With your consent, or with an opportunity for you to withdraw consent, we may share
              your information with third parties for marketing purposes, as permitted by law.
            </p>
          </section>

          <section className='small'>
            <h3>Online Postings</h3>
            <p>
              When you post content to the Site or our mobile applications, your posts may be viewed
              by all users and may be publicly distributed outside the Site and our mobile
              application in perpetuity.
            </p>
          </section>

          <section className='small'>
            <h3>Third-Party Advertisers</h3>
            <p>
              We may use third-party advertising companies to serve ads when you visit the Site or
              our mobile application. These companies may use information about your visits to the
              Site and our mobile application and other websites that are contained in web cookies
              in order to provide advertisements about goods and services of interest to you.
            </p>
          </section>

          <section className='small'>
            <h3>Affiliates</h3>
            <p>
              We may share your information with our affiliates, in which case we will require those
              affiliates to honor this Privacy Policy. Affiliates include our parent company and any
              subsidiaries, joint venture partners or other companies that we control or that are
              under common control with us.
            </p>
          </section>

          <section className='small'>
            <h3>Business Partners</h3>
            <p>
              We may share your information with our business partners to offer you certain
              products, services or promotions.
            </p>
          </section>

          <section className='small'>
            <h3>Other Third Parties</h3>
            <p>
              We may share your information with advertisers and investors for the purpose of
              conducting general business analysis. We may also share your information with such
              third parties for marketing purposes, as permitted by law.
            </p>
          </section>

          <section className='small'>
            <h3>Sale or Bankruptcy</h3>
            <p>
              If we reorganize or sell all or a portion of our assets, undergo a merger, or are
              acquired by another entity, we may transfer your information to the successor entity.
              If we go out of business or enter bankruptcy, your information would be an asset
              transferred or acquired by a third party. You acknowledge that such transfers may
              occur and that the transferee may decline honor commitments we made in this Privacy
              Policy.
            </p>
            <p>
              We are not responsible for the actions of third parties with whom you share personal
              or sensitive data, and we have no authority to manage or control third-party
              solicitations. If you no longer wish to receive correspondence, emails or other
              communications from third parties, you are responsible for contacting the third party
              directly.
            </p>
          </section>

          <section className='big'>
            <h2>TRACKING TECHNOLOGIES</h2>
          </section>

          <section className='small'>
            <h3>Cookies and Web Beacons</h3>
            <p>
              We may use cookies, web beacons, tracking pixels, and other tracking technologies on
              the Site and our mobile application to help customize the Site and our mobile
              application and improve your experience. When you access the Site or our mobile
              application, your personal information is not collected through the use of tracking
              technology. Most browsers are set to accept cookies by default. You can remove or
              reject cookies, but be aware that such action could affect the availability and
              functionality of the Site or our mobile application. You may not decline web beacons.
              However, they can be rendered ineffective by declining all cookies or by modifying
              your web browser’s settings to notify you each time a cookie is tendered, permitting
              you to accept or decline cookies on an individual basis.
            </p>
            <p>
              We may use cookies, web beacons, tracking pixels, and other tracking technologies on
              the Site and our mobile application to help customize the Site and our mobile
              application and improve your experience. For more information on how we use cookies,
              please refer to our Cookie Policy posted on the Site, which is incorporated into this
              Privacy Policy. By using the Site, you agree to be bound by our Cookie Policy.
            </p>
          </section>

          <section className='small'>
            <h3>Internet-Based Advertising</h3>
            <p>
              Additionally, we may use third-party software to serve ads on the Site and our mobile
              application, implement email marketing campaigns, and manage other interactive
              marketing initiatives. This third-party software may use cookies or similar tracking
              technology to help manage and optimize your online experience with us. For more
              information about opting-out of interest-based ads, visit the Network Advertising
              Initiative Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.
            </p>
          </section>

          <section className='small'>
            <h3>Website Analytics</h3>
            <p>
              We may also partner with selected third-party vendors to allow tracking technologies
              and remarketing services on the Site and our mobile application through the use of
              first party cookies and third-party cookies, to, among other things, analyze and track
              users’ use of the Site and our mobile application, determine the popularity of certain
              content and better understand online activity. By accessing the Site and/or our mobile
              application, you consent to the collection and use of your information by these
              third-party vendors. You are encouraged to review their privacy policy and contact
              them directly for responses to your questions. We do not transfer personal information
              to these third-party vendors. However, if you do not want any information to be
              collected and used by tracking technologies, you can visit the third-party vendor or
              the Network Advertising Initiative Opt-Out Tool or Digital Advertising Alliance
              Opt-Out Tool.
            </p>
            <p>
              You should be aware that getting a new computer, installing a new browser, upgrading
              an existing browser, or erasing or otherwise altering your browser’s cookies files may
              also clear certain opt-out cookies, plug-ins, or settings.
            </p>
          </section>

          <section className='big'>
            <h2>THIRD-PARTY WEBSITES</h2>
            <p>
              The Site and our mobile application may contain links to third-party websites and
              applications of interest, including advertisements and external services, which are
              not affiliated with us. Once you have used these links to leave the Site or our mobile
              application, any information you provide to these third parties is not covered by this
              Privacy Policy, and we cannot guarantee the safety and privacy of your information.
              Before visiting and providing any information to any third-party websites, you should
              inform yourself of the privacy policies and practices (if any) of the third party
              responsible for that website, and should take those steps necessary to, in your
              discretion, protect the privacy of your information. We are not responsible for the
              content or privacy and security practices and policies of any third parties, including
              other sites, services or applications that may be linked to or from the Site or our
              mobile application.
            </p>
          </section>

          <section className='big'>
            <h2>SECURITY OF YOUR INFORMATION</h2>
            <p>
              We use administrative, technical, and physical security measures to help protect your
              personal information. While we have taken reasonable steps to secure the personal
              information you provide to us, please be aware that despite our efforts, no security
              measures are perfect or impenetrable, and no method of data transmission can be
              guaranteed against any interception or other type of misuse. Any information disclosed
              online is vulnerable to interception and misuse by unauthorized parties. Therefore, we
              cannot guarantee complete security if you provide personal information.
            </p>
          </section>

          <section className='big'>
            <h2>POLICY FOR CHILDREN</h2>
            <p>
              We do not knowingly solicit information from or market to children under the age of
              13. If you become aware of any data we have collected from children under age 13,
              please contact us using the contact information provided below.
            </p>
          </section>

          <section className='big'>
            <h2>CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
            <p>
              Most web browsers and some mobile operating systems and our mobile applications
              include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your
              privacy preference not to have data about your online browsing activities monitored
              and collected. No uniform technology standard for recognizing and implementing DNT
              signals has been finalized. As such, we do not currently respond to DNT browser
              signals or any other mechanism that automatically communicates your choice not to be
              tracked online. If a standard for online tracking is adopted that we must follow in
              the future, we will inform you about that practice in a revised version of this
              Privacy Policy./Most web browsers and some mobile operating systems and our mobile
              applications include a Do-Not-Track (“DNT”) feature or setting you can activate to
              signal your privacy preference not to have data about your online browsing activities
              monitored and collected. If you set the DNT signal on your browser, we will respond to
              such DNT browser signals.
            </p>
          </section>

          <section className='big'>
            <h2>OPTIONS REGARDING YOUR INFORMATION</h2>
          </section>

          <section className='small'>
            <h3>Account Information</h3>
            <p>
              You may at any time review or change the information in your account or terminate your
              account by:
            </p>
            <ul>
              <li>Logging into your account settings and updating your account</li>
              <li>Contacting us using the contact information provided below</li>
            </ul>
            <p>
              Upon your request to terminate your account, we will deactivate or delete your account
              and information from our active databases. However, some information may be retained
              in our files to prevent fraud, troubleshoot problems, assist with any investigations,
              enforce our Terms of Use and/or comply with legal requirements.
            </p>
          </section>

          <section className='small'>
            <h3>Emails and Communications</h3>
            <p>
              If you no longer wish to receive correspondence, emails, or other communications from
              us, you may opt-out by:
            </p>
            <ul>
              <li>
                Noting your preferences at the time you register your account with the Site or our
                mobile application
              </li>
              <li>Logging into your account settings and updating your preferences.</li>
              <li>Contacting us using the contact information provided below</li>
            </ul>
            <p>
              If you no longer wish to receive correspondence, emails, or other communications from
              third parties, you are responsible for contacting the third party directly.
            </p>
          </section>

          <section className='big'>
            <h2>CALIFORNIA PRIVACY RIGHTS</h2>
            <p>
              California Civil Code Section 1798.83, also known as the “Shine The Light” law,
              permits our users who are California residents to request and obtain from us, once a
              year and free of charge, information about categories of personal information (if any)
              we disclosed to third parties for direct marketing purposes and the names and
              addresses of all third parties with which we shared personal information in the
              immediately preceding calendar year. If you are a California resident and would like
              to make such a request, please submit your request in writing to us using the contact
              information provided below.
            </p>
            <p>
              If you are under 18 years of age, reside in California, and have a registered account
              with the Site or our mobile application, you have the right to request removal of
              unwanted data that you publicly post on the Site or our mobile application. To request
              removal of such data, please contact us using the contact information provided below,
              and include the email address associated with your account and a statement that you
              reside in California. We will make sure the data is not publicly displayed on the Site
              or our mobile application, but please be aware that the data may not be completely or
              comprehensively removed from our systems.
            </p>
          </section>

          <section className='big'>
            <h2>CONTACT US</h2>
            <p>
              If you have questions or comments about this Privacy Policy, please contact us at:
            </p>
            <div className='info'>
              <address>D2D Auto Auction LLC (dba privauto)</address>
              <address>4635 N Thompson St</address>
              <address>Springdale, AR 72764 USA</address>
              <address>
                Phone: <a href='tel:833-323-2248'>833-323-2248</a>
              </address>
              <address>
                <a className='mail' href='mailto:Info@drivrzxchange.com'>
                  Info@drivrzxchange.com
                </a>
              </address>
            </div>
          </section>
        </main>
      </div>

      <style jsx>{`
        .container {
          max-width: 193rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .title {
          padding: 5.1rem 0 4.7rem;

          :global(h1) {
            text-align: center;
          }

          span {
            display: block;
            text-align: center;
            color: var(--secondary-text-color);
            font-size: 1.4rem;
          }
        }

        h2 {
          font-size: 2.8rem;
          text-transform: uppercase;
        }

        h3 {
          font-size: 2rem;
        }

        p {
          font-size: 1.6rem;
        }

        li {
          margin: 0 0 0 2rem;
          list-style: disc;
          list-style-position: inside;
          font-size: 1.6rem;
        }

        .big {
          p {
            margin: 2rem 0;
          }
        }

        .small p {
          margin: 1rem 0;
        }

        .content {
          .big {
            margin: 2.5rem 0 0;
          }

          .small {
            margin: 2rem 0 0;
          }
        }

        .info {
          address {
            margin: 0 0 0.8rem;
            font-size: 1.6rem;
            font-style: normal;
          }

          a {
            color: var(--text-link-color);
          }
        }

        @media (max-width: 1024px) {
          .container {
            max-width: 100%;
            padding: 0 1.1rem 2rem;
          }

          .title {
            padding: 2.5rem 1.2rem 2.7rem;

            span {
              font-size: 1.2rem;
            }
          }

          h2 {
            font-size: 2rem;
          }

          h3 {
            font-size: 1.8rem;
          }

          p {
            font-size: 1.4rem;
          }

          li {
            margin: 0 0 0 1rem;
            font-size: 1.4em;
          }

          .big {
            p {
              margin: 1.5rem 0;
            }
          }

          .small p {
            margin: 0.8rem 0;
          }

          .content {
            .big {
              margin: 2rem 0 0;
            }

            .small {
              margin: 1.6rem 0 0;
            }
          }

          .info {
            address {
              margin: 0 0 0.5rem;
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </>
  )
}

Privacy.getInitialProps = () => ({
  namespacesRequired: ['common'],
})
